import ViewHeading from '../components/ViewHeading.jsx';
/**
 * routes/ModulesGrid.jsx -- Port de renderModulesGrid() en src/js/modules.js.
 *
 * Comparacion linea a linea con el original:
 *   - Original: construye un string de HTML a mano (moduleCardHtml),
 *     lo mete con innerHTML, y LUEGO busca los botones recien creados
 *     en el DOM para atarles un addEventListener.
 *   - Aqui: JSX describe el resultado final directo, y onClick ya es
 *     parte de la descripcion -- no hay un segundo paso de "ahora busca
 *     en el DOM lo que acabas de escribir". Ese es, en una sola vista,
 *     el argumento completo de "React te ahorra el fetch-lo-que-pintaste".
 *
 * El filtrado por permiso (`visibleModules()` en el original) aqui es
 * un .filter() con el `can()` del Context -- misma regla, mismo lugar
 * conceptual (doc 22 Fase 5: "un modulo no aparece si no hay permiso").
 */
import { useNavigate } from 'react-router-dom';
import { useSession } from '../state/useSession.js';
import { MODULE_DEFS } from './moduleDefs.js';

export default function ModulesGrid() {
  const navigate = useNavigate();
  const { can } = useSession();
  const visible = MODULE_DEFS.filter((m) => can(m.permiso));

  return (
    <>
      <ViewHeading title="Inicio" icon="home" description="Elige un módulo para consultar y gestionar tus operaciones." />
      <div className="modules-grid">
        {visible.map((m) => (
          <button key={m.id} type="button" className="module-card" onClick={() => navigate(m.path)}>
            <span className="module-card-icon">
              <span className="material-symbols-rounded" aria-hidden="true">{m.icon}</span>
            </span>
            <h3 className="module-card-title">{m.title}</h3>
            <p className="module-card-desc">{m.desc}</p>
            <span className="module-card-go">
              Entrar
              <span className="material-symbols-rounded" aria-hidden="true">arrow_forward</span>
            </span>
          </button>
        ))}
        {visible.length === 0 && (
          <p className="view-heading-sub">Este perfil no tiene modulos visibles todavia.</p>
        )}
      </div>
    </>
  );
}
